import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";

/** BlogTeaser — three latest article headlines on the homepage.
 *  Renders nothing until published articles exist. */
export const BlogTeaser = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/blog?limit=3`)
      .then((r) => (r.ok ? r.json() : { rows: [] }))
      .then((d) => setRows((d.rows || []).slice(0, 3)))
      .catch(() => {});
  }, []);

  if (rows.length === 0) return null;

  return (
    <section
      id="blog-teaser"
      data-testid="blog-teaser"
      className="relative py-16 sm:py-20 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">
              [ Fresh from the blog · new guides daily ]
            </div>
            <h2 className="font-display text-2xl sm:text-4xl font-semibold leading-tight text-white">
              Battery guides for <span className="brand-text-gradient">every EV owner.</span>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-teaser-all-link"
            className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition-colors shrink-0"
          >
            All articles
            <ArrowRight className="w-4 h-4" strokeWidth={2.2} />
          </Link>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {rows.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              className="block rounded-2xl border border-white/10 bg-white/[0.02] p-5 hover:border-white/25 transition-colors"
              data-testid="blog-teaser-card"
            >
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 font-mono text-[10px] uppercase tracking-wider text-zinc-500">
                <span>
                  {new Date(p.published_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                </span>
                <span className="inline-flex items-center gap-1">
                  <Clock className="w-3 h-3" /> {p.reading_min} min
                </span>
                {(p.tags || []).slice(0, 1).map((t) => (
                  <span key={t} className="rounded-full border border-white/10 px-2 py-0.5 text-[#39FF14]">{t}</span>
                ))}
              </div>
              <h3 className="mt-2 text-white font-semibold text-[15px] leading-snug">{p.title}</h3>
              {p.excerpt && (
                <p className="mt-1.5 text-[12px] text-zinc-500 leading-relaxed line-clamp-2">{p.excerpt}</p>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
